const menuRoleOptions = [
  { value: "ADMIN", label: "Админ" },
  { value: "FINANCIER", label: "Финансист" },
  { value: "DIRECTOR", label: "Директор" },
  { value: "ACCOUNTANT", label: "Бухгалтер" }
];

export default function TemplatePage({
  templateColumns,
  directories,
  actionColumns,
  updateTemplateColumn,
  addTemplateColumn,
  clearTemplate,
  removeTemplateColumn,
  moveTemplateColumn,
  launchTemplate,
  addActionColumn,
  updateActionColumn,
  updateActionColumnOption,
  removeActionColumn
}) {
  return (
    <div>
      <h1>Шаблон создания платежа</h1>

      <div className="template-toolbar">
        <button onClick={addTemplateColumn}>
          Добавить столбец
        </button>

        <button onClick={clearTemplate}>
          Создать с нуля
        </button>

        <button className="launch-btn" onClick={launchTemplate}>
          Запустить шаблон
        </button>
      </div>

      <div className="template-list">
        {templateColumns.map((column, index) => (
          <div className="template-row" key={column.id}>
            <input
              value={column.label}
              onChange={(e) =>
                updateTemplateColumn(column.id, "label", e.target.value)
              }
              placeholder="Название столбца"
            />

            <select
              value={column.format}
              onChange={(e) =>
                updateTemplateColumn(column.id, "format", e.target.value)
              }
            >
              <option value="text">Текст</option>
              <option value="number">Число</option>
              <option value="date">Дата</option>
              {directories.map((directory) => (
                <option key={directory.id} value={`directory:${directory.id}`}>
                  {directory.savedName}
                </option>
              ))}
            </select>

            <label className="required-toggle">
              <input
                type="checkbox"
                checked={column.required}
                onChange={(e) =>
                  updateTemplateColumn(column.id, "required", e.target.checked)
                }
              />
              Обязательный
            </label>

            <button
              onClick={() => moveTemplateColumn(column.id, -1)}
              disabled={index === 0}
            >
              ↑
            </button>

            <button
              onClick={() => moveTemplateColumn(column.id, 1)}
              disabled={index === templateColumns.length - 1}
            >
              ↓
            </button>

            <button
              className="remove-column-btn"
              onClick={() => removeTemplateColumn(column.id)}
            >
              Удалить
            </button>
          </div>
        ))}
      </div>

      <div className="actions-settings">
        <div className="actions-settings-head">
          <div>
            <h2>Столбцы выбора</h2>
            <p>
              Создавайте любые колонки с выпадающими списками: согласование, оплата, проверка и другие этапы.
            </p>
          </div>

          <button onClick={addActionColumn}>
            Добавить столбец выбора
          </button>
        </div>

        <div className="action-columns-list">
          {actionColumns.map((column) => (
            <div className="action-column-card" key={column.id}>
              <div className="action-column-main">
                <input
                  value={column.label}
                  onChange={(e) =>
                    updateActionColumn(column.id, "label", e.target.value)
                  }
                  placeholder="Название столбца"
                />

                <textarea
                  value={column.optionsText}
                  onChange={(e) =>
                    updateActionColumn(column.id, "optionsText", e.target.value)
                  }
                  placeholder={"Каждый вариант с новой строки\nНапример:\nНа проверке\nОдобрено\nОтказано"}
                  rows={4}
                />

                <button
                  className="remove-column-btn"
                  onClick={() => removeActionColumn(column.id)}
                >
                  Удалить столбец
                </button>
              </div>

              <div className="action-options-list">
                <strong>Варианты для меню</strong>

                {column.options.map((option) => (
                  <div className="action-menu-option" key={option.id}>
                    <label className="required-toggle">
                      <input
                        type="checkbox"
                        checked={option.showInMenu}
                        onChange={(e) =>
                          updateActionColumnOption(
                            column.id,
                            option.id,
                            "showInMenu",
                            e.target.checked
                          )
                        }
                      />
                      Показывать меню для: {option.label}
                    </label>

                    <input
                      value={option.menuLabel || option.label}
                      onChange={(e) =>
                        updateActionColumnOption(
                          column.id,
                          option.id,
                          "menuLabel",
                          e.target.value
                        )
                      }
                      placeholder="Название меню слева"
                    />

                    <div className="menu-role-list">
                      {menuRoleOptions.map((role) => {
                        const roles = option.menuRoles || menuRoleOptions.map((item) => item.value);

                        return (
                          <label className="required-toggle" key={role.value}>
                            <input
                              type="checkbox"
                              checked={roles.includes(role.value)}
                              onChange={(e) => {
                                const nextRoles = e.target.checked
                                  ? [...new Set([...roles, role.value])]
                                  : roles.filter((item) => item !== role.value);

                                updateActionColumnOption(
                                  column.id,
                                  option.id,
                                  "menuRoles",
                                  nextRoles
                                );
                              }}
                            />
                            {role.label}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
